// Texty modalu „Pridané do košíka" — slovenské dvojče locale/cs/cartModal.js.
import { NBSP } from '../../modules/money.js';
import { plural } from '../plural.js';

export default {
  title: 'Pridané do košíka',
  back: 'Späť do obchodu',
  cart: 'Nákupný košík',
  upsellTitle: 'Ostatní zákazníci tiež nakúpili',
  freeShipScope: 'na výdajné miesto',
  inCart: (count, price) => 'V košíku máte ' + count + ' ' + plural(count, ['položku', 'položky', 'položiek']) + ' za ' + price,
  sendsToday: (cutoff) => 'odosielame dnes pri objednaní do ' + cutoff,
  sendsFrom: (label) => label.replace(/^Expedujeme/, 'odosielame'),
  shipProgress: 'Postup k doprave zadarmo',
  flagNew: 'Novinka',
  flagTip: 'Tip',
  flagAction: 'Akcia',
  inStockRe: /^skladom/i,
  inStock: 'Skladom',
  chooseVariant: 'Vybrať variant',
  addToCart: 'Do košíka',
  added: 'Pridané',
  close: 'Zavrieť',
  prev: 'Predchádzajúce produkty',
  next: 'Ďalšie produkty',
  save: (price) => 'Ušetríte ' + price,
  freeShipDone: (scope) => 'Dopravu ' + scope + ' máte zadarmo!',
  leftPre: 'Ešte',
  leftMid: (scope) => 'a' + NBSP + 'dopravu ' + scope + ' máte',
  leftFree: 'zadarmo',
  promoNote: (carrier, price, until) =>
    'Dovtedy ' + carrier + ' na výdajné miesto za ' + price + ', akcia platí do ' + until.replace(/\.$/, '') + '.',
};
